import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {CommonsModule} from "../../commons/angular/commons.module";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {TranslateModule} from "@ngx-translate/core";
import {NgxPermissionsModule} from "ngx-permissions";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {ScrollingModule as ScrollingModuleExperimental} from "@angular/cdk-experimental/scrolling";
import {
  ScheduleAvailabilityApprovalDialogComponent
} from "./components/schedule-availability-approval-dialog/schedule-availability-approval-dialog.component";


@NgModule({
  declarations: [
    ScheduleAvailabilityApprovalDialogComponent
  ],
  imports: [
    BrowserModule,
    CommonsModule,
    NgbModule,
    ScrollingModule,
    ScrollingModuleExperimental,
    TranslateModule.forChild(),
    NgxPermissionsModule.forChild()
  ],
  providers: [],
  exports: []
})

export class ScheduleModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapScheduleModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(ScheduleModule);
};

export const downgradedScheduleModule = downgradeModule(bootstrapScheduleModule);
